import React, {Component} from 'react';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

class Reinvest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            partialReinvestAmt: '0',
            withdrawAfterReinvest: 'no'
        };

        this.handleWithdrawAfterReinvestChange = this.handleWithdrawAfterReinvestChange.bind(this);
        this.handlePartialReinvestChange = this.handlePartialReinvestChange.bind(this);
        this.handleReinvest = this.handleReinvest.bind(this);
        this.handlePartialReinvest = this.handlePartialReinvest.bind(this);
        this.handleWithdrawClick = this.handleWithdrawClick.bind(this);
    }

    async componentDidMount() {

    }

    handleWithdrawAfterReinvestChange(event) {
        let withdrawAfter = event.target.getAttribute('value');
        this.setState({
            withdrawAfterReinvest: withdrawAfter
        });
    }

    handlePartialReinvestChange(event) {
        let partialReinvestAmt = event.target.value;
        console.log(partialReinvestAmt);
        this.setState({
            partialReinvestAmt: partialReinvestAmt
        });
    }

    async handleReinvest(event) {
        try {
            await this.props.data.P3XTokenContract.methods.reinvest().send({
                from: this.props.data.address
            }, (error, transactionHash) => {
                if (!error) {
                    toast.success(this.props.data.txtResponse.reinvest.transSuccess);
                }
                else {
                    toast.error(this.props.data.txtResponse.genericSendingTransErr);
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    async handlePartialReinvest() {
        try {
            let amt = this.state.partialReinvestAmt;
            if (amt <= 0) {
                toast.error(this.props.data.txtResponse.reinvestPartial.amtErr);
                console.log(this.props.data.txtResponse.reinvestPartial.amtErr);
                return;
            }
            if (amt > this.props.data.totalDividendsOf) {
                toast.error(this.props.data.txtResponse.reinvestPartial.totalDivsErr);
                console.log(this.props.data.txtResponse.reinvestPartial.totalDivsErr);
                return;
            }
            let withdrawAfter = this.state.withdrawAfterReinvest === 'yes' ? true : false;
            await this.props.data.P3XTokenContract.methods.reinvestPartial(this.props.data.web3.utils.toWei(amt, "ether"), withdrawAfter).send({
                from: this.props.data.address
            }, (error, transactionHash) => {
                if (!error) {
                    toast.success(this.props.data.txtResponse.reinvestPartial.transSuccess);
                }
                else {
                    toast.error(this.props.data.txtResponse.genericSendingTransErr);
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    async handleWithdrawClick() {
        try {
            await this.props.data.P3XTokenContract.methods.withdraw().send({
                from: this.props.data.address
            }, (error, transactionHash) => {
                if (!error) {
                    toast.success(this.props.data.txtResponse.withdraw.transSuccess);
                }
                else {
                    toast.error(this.props.data.txtResponse.genericSendingTransErr);
                }
            });
        }
        catch (error) {
           console.log(error);
        }
    }

    render() {
        return (

            <div className="row">
                <div className="col-12 mt-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
                                    <h5 className="card-title text-center">Reinvest Dividends</h5>
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <ul className="reinvest-tabs nav nav-pills nav-justified mb-3  text-center" role="tablist">
                                                <li className="nav-item">
                                                    <a className="nav-link active" data-toggle="pill" href="#tab-reinvest-all" role="tab" aria-selected="true"> All Divs </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" data-toggle="pill" href="#tab-reinvest-partial" role="tab" aria-selected="false"> Partial Divs </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="tab-reinvest-all" role="tabpanel">
                                            <button id="btn-reinvest" onClick={this.handleReinvest} type="button" className="btn btn-primary btn-block">Reinvest</button>
                                        </div>
                                        <div className="tab-pane fade" id="tab-reinvest-partial" role="tabpanel">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">Reinvest Amount:</span>
                                                </div>
                                                <input id="reinvest-eth-amount" type="number" className="form-control" onChange={this.handlePartialReinvestChange}
                                                       value={this.state.partialReinvestAmt}/>
                                                <div className="input-group-append">
                                                    <span className="input-group-text">ETH</span>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-8 col-form-label">Withdraw Remaining Divs After Reinvestment:</label>
                                                <div className="col-4 text-right">
                                                    <div className="btn-group btn-group-toggle pull-right" data-toggle="buttons">
                                                        <label className="withdraw-after-reinvest btn btn-outline-primary active" onClick={this.handleWithdrawAfterReinvestChange} value="no">
                                                            <input type="radio" name="withdraw-after" autoComplete="off" value="no" checked onChange={this.handleWithdrawAfterReinvestChange}/> No
                                                        </label>
                                                        <label className="withdraw-after-reinvest btn btn-outline-primary" onClick={this.handleWithdrawAfterReinvestChange} value="yes">
                                                            <input type="radio" name="withdraw-after" autoComplete="off" value="yes"/> Yes
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <button id="btn-reinvest-partial" onClick={this.handlePartialReinvest} type="button" className="btn btn-primary btn-block">Reinvest Partial</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
                                    <h5 className="card-title text-center">Withdraw Dividends</h5>
                                    <div className="form-group row mb-0">
                                        <div className="col-12 text-center">
                                            <div className="input-group mb-3" style={{cursor: 'not-allowed'}}>
                                                <input id="txt-eth-withdraw" type="text" readOnly className="form-control text-center" style={{pointerEvents: 'none'}}
                                                       value={this.props.data.totalDividendsOf_Display}/>
                                                <div className="input-group-append">
                                                    <span className="input-group-text">ETH</span>
                                                </div>
                                            </div>
                                            <button id="btn-withdraw" type="button" className="btn btn-primary btn-block mt-3" onClick={this.handleWithdrawClick}>Withdraw</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer/>
            </div>

        );
    }
}

export default Reinvest;